import { inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import {
  SignInDto,
  UserDto,
  UserService,
  AdminService,
  AdminDto,
} from '@api-client';
import {
  AlertService,
  BaseStore,
  LocalStorageService,
  ToastService,
} from '@client';
import { TOKEN_KEY } from '@common';
import { lastValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AdminStore extends BaseStore<AdminDto | undefined> {
  adminService = inject(AdminService);
  localStorageService = inject(LocalStorageService);
  toastService = inject(ToastService);
  alertService = inject(AlertService);
  router = inject(Router);

  constructor() {
    super(undefined);
  }

  admin = toSignal(this.state$);

  async login(body: SignInDto) {
    this.adminService.adminControllerSignIn({ body }).subscribe({
      next: async (data) => {
        localStorage.setItem(
          TOKEN_KEY.ADMIN_ACCESS_TOKEN_KEY,
          data.accessToken!,
        );
        localStorage.setItem(
          TOKEN_KEY.ADMIN_REFRESH_TOKEN_KEY,
          data.refreshToken!,
        );

        this.router.navigate(['/dashboard']);
        await this.fetch();
      },
    });
  }

  async fetch() {
    const admin = await lastValueFrom(this.adminService.adminControllerMe());
    this.updateState(admin);
  }

  async logout() {
    this.alertService
      .open({
        content: '로그아웃 하시겠습니까?',
        title: '로그아웃',
        type: 'danger',
      })
      .closed.subscribe(async (data) => {
        if (data?.action === 'confirm') {
          await lastValueFrom(this.adminService.adminControllerLogout());

          this.localStorageService.remove(TOKEN_KEY.ADMIN_ACCESS_TOKEN_KEY);
          this.localStorageService.remove(TOKEN_KEY.ADMIN_REFRESH_TOKEN_KEY);

          this.updateState(undefined);

          this.router.navigate(['/login']);
          this.toastService.success('로그아웃 되었습니다.');
        }
      });
  }
}
